// extracted by mini-css-extract-plugin
var _1 = "logo-O9i_1";
var _2 = "mobile-l5R_p";
export { _1 as "logo", _2 as "mobile" }
